import convertReadWriteRecipientToRecipientPersonaProps from '../utils/convertReadWriteRecipientToRecipientPersonaProps';
import addRecipientToRecipientWell from 'owa-recipient-common/lib/actions/addRecipientToRecipientWell';
import removeRecipientFromRecipientWell from 'owa-recipient-common/lib/actions/removeRecipientFromRecipientWell';
import { orchestrator } from 'satcheljs';
var selectedPeopleLists;
export function subscribeToRecipientsChangeExternallyEvent(selectedPeopleList) {
    selectedPeopleLists = selectedPeopleList;
}
export function unsubscribeToRecipientsChangeExternallyEvent(selectedPeopleList) {
    selectedPeopleLists = null;
}
orchestrator(addRecipientToRecipientWell, function (actionMessage) {
    updateSelectedPeopleList(actionMessage.recipientWellRecipients);
});
orchestrator(removeRecipientFromRecipientWell, function (actionMessage) {
    updateSelectedPeopleList(actionMessage.recipientWellRecipients);
});
function updateSelectedPeopleList(recipientWell) {
    if (selectedPeopleLists) {
        selectedPeopleLists.updateItems(convertReadWriteRecipientToRecipientPersonaProps(recipientWell.recipients));
    }
}
//# sourceMappingURL=onRecipientsChangeExternally.js.map